export default "__VITE_ASSET__2135e71c__"